import { AdTypeSchema as e } from "./schemas.js";
const s = (n) => n !== e.enum.Popunder && n !== e.enum.Interstitial && n !== e.enum.Link, p = (n) => n !== e.enum.Video && n !== e.enum.VideoSlider, d = (n) => n === e.enum.Native, a = (n) => n === e.enum.Popunder || n === e.enum.Link, o = [
  e.enum.Multispot,
  e.enum.InPage,
  e.enum.Link
], c = (n) => !o.includes(n), i = [
  e.enum.Popunder,
  e.enum.Banner,
  e.enum.Native,
  e.enum.Multispot,
  e.enum.Interstitial,
  e.enum.InPage,
  e.enum.Link,
  e.enum.Video,
  e.enum.VideoSlider,
  e.enum.OutstreamVideo
], r = new Map(
  i.map((n, t) => [n, t])
), u = (n) => r.get(n) ?? i.length, P = (n, t) => u(n) - u(t);
export {
  i as AD_TYPE_DISPLAY_ORDER,
  u as adTypeDisplayRank,
  P as compareAdTypeDisplayOrder,
  s as isCreativeRequiredForAdType,
  p as isLandingRequiredForAdType,
  c as isSupportedInCreativeGroup,
  a as supportsFraudulentTrafficUrl,
  d as supportsRotatorIndex
};
//# sourceMappingURL=ad-type-policy.js.map
